export const AUTHENTICATE_USER = "Auth.AUTHENTICATE_USER";
export const AUTHENTICATE_USER_SUCCESS = "Auth.AUTHENTICATE_USER_SUCCESS";
export const AUTHENTICATE_USER_FAILURE = "Auth.AUTHENTICATE_USER_FAILURE";

export const LOGOUT = "Auth.LOGOUT";
